import { Form, FormGroup, Label, Input, Row, Col, Button } from "reactstrap"
import React, { useState, useEffect } from "react"
import EnvAuditService from "services/applications/envAudit/EnvAuditService"
import { AvField } from "availity-reactstrap-validation"

const envAuditService = new EnvAuditService(
  JSON.parse(localStorage.getItem("authUser"))
)

const OfficerChecklistReviewForm = props => {
  const [formData, setFormData] = useState({})
  const [questions, setQuestions] = useState([])

  useEffect(() => {
    fetchReviewQuestions()
    prepareExistingChecklist()
  }, [])

  const fetchReviewQuestions = () => {
    envAuditService.getAllChecklistQuestions().then(response => {
      //   console.log("questions -----> ", response);
      if (response.status) {
        setQuestions(response.data)
      }
    })
  }

  const prepareExistingChecklist = () => {
    // console.log(props.existingChecklists)
    if (props.existingChecklists.length > 0) {
    //   console.log("props existingChecklists", props.existingChecklists)

      const formObject = {}

      props.existingChecklists.forEach(item => {
        const questionKey = `question-${item.check_list_question_id}`
        const notesKey = `notes-${item.check_list_question_id}`

        // Add the compliance status as "Yes" or "No"
        formObject[questionKey] = item.is_compliant ? "Yes" : "No"

        // Add officer notes if available
        if (item.officer_notes) {
          formObject[notesKey] = item.officer_notes
        }
      })

    //   console.log("new-form-object ", formObject)
      setFormData(formObject)

      // force parent to store existing data in checklistFormData
      props.handleChange(formObject);
    }
  }

  const handleChange = e => {
    const { name, value } = e.target
    setFormData((prevState) => {
        const updatedFormData = { ...prevState, [name]: value };
        
        props.handleChange(updatedFormData);
        
        return updatedFormData;
      });
  }

  //   not being used. remove
  const handleSubmit = e => {
    e.preventDefault()

    const applicationId = 102 // Replace with the actual application ID
    const responses = questions.map(question => {
      const isCompliant = formData[`question-${question.id}`] === "Yes"
      const officerNotes = formData[`notes-${question.id}`] || ""

      return {
        application_id: applicationId,
        check_list_question_id: question.id,
        is_compliant: isCompliant,
        officer_notes: officerNotes,
      }
    })

    // console.log("Form Responses:", responses)
    // You can now send `responses` to your backend API.
  }

  

  return (
    <div>
      <hr />
      <h3>Reviewer Checklist</h3>

      {questions.map(question => (
        <div key={question.id}>
          <FormGroup>
            <Label for={`question-${question.id}`}>{question.questions}</Label>
            <AvField
              type="select"
              name={`question-${question.id}`}
              id={`question-${question.id}`}
              value={formData[`question-${question.id}`] || ""}
              onChange={handleChange}
              required
              disabled={props.isReadOnly}
            >
              <option value="" disabled>
                Select an option
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </AvField>
          </FormGroup>
          <FormGroup>
            <Label for={`notes-${question.id}`}>
              Officer Notes (Optional):
            </Label>
            <AvField
              type="textarea"
              name={`notes-${question.id}`}
              id={`notes-${question.id}`}
              value={formData[`notes-${question.id}`] || ""}
              onChange={handleChange}
              placeholder="Add notes here..."
              disabled={props.isReadOnly}
            />
          </FormGroup>
        </div>
      ))}
    </div>
  )
}

export default OfficerChecklistReviewForm
